/**
 * @generated SignedSource<<dd15e2d49ddf5c2f3c0dea127cc80cef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FlowELearningContentConfigType = "FlowELearningContent_DirectFeedback" | "FlowELearningContent_SimplyContinue";
import { FragmentRefs } from "relay-runtime";
export type setDirectFeedbackFlowConfigForm_DirectFeedbackFlowELearningContentConfigFragment$data = {
  readonly configType: FlowELearningContentConfigType;
  readonly id: string;
  readonly minNumTriesTillShowAnswer: number;
  readonly " $fragmentType": "setDirectFeedbackFlowConfigForm_DirectFeedbackFlowELearningContentConfigFragment";
};
export type setDirectFeedbackFlowConfigForm_DirectFeedbackFlowELearningContentConfigFragment$key = {
  readonly " $data"?: setDirectFeedbackFlowConfigForm_DirectFeedbackFlowELearningContentConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"setDirectFeedbackFlowConfigForm_DirectFeedbackFlowELearningContentConfigFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "setDirectFeedbackFlowConfigForm_DirectFeedbackFlowELearningContentConfigFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minNumTriesTillShowAnswer",
      "storageKey": null
    }
  ],
  "type": "DirectFeedbackFlowELearningContentConfig",
  "abstractKey": null
};

(node as any).hash = "793b3ee9101c0cbce4a0dbac8b46ae21";

export default node;
